export default {
  ENV: import.meta.env.VITE_ENV,
  BUILD: import.meta.env.VITE_BUILD,
  USE_ANALYTICS: parseBoolean(import.meta.env.VITE_USE_ANALYTICS),
  USE_SENTRY: parseBoolean(import.meta.env.VITE_USE_SENTRY),
  API_KEY_GA: import.meta.env.VITE_API_KEY_GA,
  ISP_DESIGN_CENTER_URL: import.meta.env.VITE_ISP_DESIGN_CENTER_URL,
} as const;

function parseBoolean(value: string | boolean | undefined | null, defaultValue = false) {
  if (value == null) {
    return defaultValue;
  }

  // If the value is already a boolean, return it
  if (typeof value === 'boolean') {
    return value;
  }

  // Return true only if the value is a string 'true', otherwise - false
  return value.toLowerCase() === 'true';
}
